module.exports = __webpack_public_path__ + "static/media/without-bulletins.0eb1b9dc.svg";